'use client'

import { useSyncExternalStore } from 'react'

const noopSubscribe = () => () => {}

/**
 * Hydration-safe boolean: false during the server render AND the hydrating client
 * render, true straight after (and on every later client-side mount).
 *
 * Gate any text that depends on the viewer's clock, zone or locale behind it. A
 * server-rendered page prints the SERVER's (UTC) and the browser's first render the
 * viewer's, and React 19 cannot hydrate a text node that differs — it throws #418
 * and rebuilds the tree (D7: /announcements' "Last refreshed", the report date chips).
 *
 * useSyncExternalStore rather than a mounted flag set in an effect: the server
 * snapshot is what hydration renders, React re-renders once with the client
 * snapshot, and a component mounted after hydration reads true at once (no flash).
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  )
}
